// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__YUQZR","rootSuccess":"CompleteLink_rootSuccess__w_NF2","rootFailure":"CompleteLink_rootFailure__s0Rg3","isDisabled":"CompleteLink_isDisabled__1EvL0"};